// Styles for ConsentList go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledLegalConsents = styled.div`
  &.m-legal-consents-container {
    .legal-text-link {
      margin: 0;
      font-size: 0.875rem;
    }

    .skeleton-loader {
      width: 100%;
      height: ${toRem(40)};
    }
  }
`;
